import { isEmpty } from 'lodash';

// BACnet units listed under "Ungrouped BACnet Devices" in Control: engaged and backed by a template
export const isControllableBacnetUnit = (unit: any): boolean =>
  !!unit?.isEngaged &&
  (!!unit.uiTemplate || !!unit.entityTemplate || !isEmpty(unit.paramTemplateData) || !!unit.paramTemplate);

// Modbus units listed under "Ungrouped Modbus Devices" in Control. Skip units whose device isn't bound yet —
// an unbound device has nothing live to control (mirrors the BACnet isEngaged check).
export const isControllableModbusUnit = (unit: any): boolean =>
  !!unit?.isVisible && unit.rows?.length > 0 && !!unit.deviceEngaged;
